import React from "react";

interface TextfieldProps {
  label: string;
  placeholder: string;
  value?: string;
  onChange?: (value: string) => void;
  type?: string;
  className?: string;
}

// Frame15 component - Label container
const Frame15: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
      <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
        <p className="block leading-[18px]">{label}</p>
      </div>
    </div>
  );
};

// Frame13 component - Input container
const Frame13: React.FC<{
  placeholder: string;
  value?: string;
  onChange?: (value: string) => void;
  type?: string;
}> = ({ placeholder, value, onChange, type = "text" }) => {
  return (
    <div className="bg-[#faf9fb] h-12 relative rounded-2xl shrink-0 w-full">
      <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
      <div className="flex flex-row items-center justify-center relative size-full">
        <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center px-4 py-2 relative w-full">
          <input
            type={type}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            placeholder={placeholder}
            className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left bg-transparent border-none outline-none placeholder:opacity-30 placeholder:text-[#211f26]"
          />
        </div>
      </div>
    </div>
  );
};

// Main Textfield component
export const Textfield: React.FC<TextfieldProps> = ({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  className = "",
}) => {
  return (
    <div
      className={`box-border content-stretch flex flex-col gap-1 items-start justify-start p-0 relative shrink-0 w-full ${className}`}
      data-name="Textfield"
    >
      <Frame15 label={label} />
      <Frame13
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        type={type}
      />
    </div>
  );
};

export default Textfield;
